import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import Header from "../Components/Big/Header";
import User from "../Components/DashboardViews/User";
import UserProfil from "../Components/DashboardViews/UserProfil";
import Main from "../Components/DashboardViews/Main";
import Nomenclature from "../Components/DashboardViews/Nomenclature";
import Marketing from "../Components/DashboardViews/Marketing";
import Sidebar from "../Components/Big/Sidebar";
import BottomNavigation from "../Components/Big/BottomNavigation";
import Grid from "@mui/material/Grid2";

const Dashboard = () => {
  const [activeComponent, setActiveComponent] = useState("dashboard");
  const [selectedUserId, setSelectedUserId] = useState(null);

  const isDesktop = useMediaQuery("(min-width:900px)");

  const handleNavigationClick = (component) => {
    setActiveComponent(component);
  };

  const handleUserClick = (userId) => {
    setSelectedUserId(userId);
    setActiveComponent("userProfil");
  };

  const renderContent = () => {
    switch (activeComponent) {
      case "dashboard":
        return <Main />;
      case "user":
        return <User onUserClick={handleUserClick} />;
      case "userProfil":
        return <UserProfil userId={selectedUserId} />;
      case "nomenclature":
        return <Nomenclature />;
      case "marketing":
        return <Marketing />;
      default:
        return <Main />;
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Affichage de la Sidebar sur desktop */}
      {isDesktop && <Sidebar onClickItem={handleNavigationClick} />}

      <Grid container direction="column" sx={{ flexGrow: 1, height: "100%" }}>
        <Grid>
          <Header />
        </Grid>
        <Grid
          item
          sx={{
            flexGrow: 1,
            overflow: "auto", // Permet le défilement vertical ET horizontal
            paddingTop: 10,
            paddingLeft: { xs: 2, md: 4 },
            paddingRight: { xs: 2, md: 4 },
            paddingBottom: { xs: 6, md: 8 },
            backgroundColor: "#f8f9fa",
            width: "100%",
          }}
        >
          {renderContent()}
        </Grid>
      </Grid>

      {/* Affichage de la BottomNavigation sur mobile */}
      {!isDesktop && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1300,
            backgroundColor: "#f8f9fa",
          }}
        >
          <BottomNavigation onClickItem={handleNavigationClick} />
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
